/* ============================================
   PERSONALIZADOR DE POLERAS v5
   - Canvas standalone (reemplaza galería Dawn)
   - Bloques por Color + Ubicación + Imagen
   - Detecta cambio de color en Dawn
   - Snapping, medidas cm, límites, upload a API
   - 1 estampado por vista
   ============================================ */

(function () {
  'use strict';

  var SNAP_THRESHOLD = 10;
  var CANVAS_MAX_WIDTH = 1200;
  var CART_BUTTON_SELECTOR = 'button[name="add"], button.product-form__submit, .product-form__submit, button.m-add-to-cart, .m-add-to-cart';

  var state = {
    currentColor: null,
    currentViews: [],       // vistas filtradas por color actual
    currentViewIndex: 0,
    canvas: null,
    viewsByColor: {},       // { "Negro": [...], "Rojo": [...] }
    colorsList: [],
    stampsByLocation: {},   // { "Frente": { dataUrl, fileName, position }, "Espalda": {...} }
    config: {
      stampPrice: 0,
      currency: '$',
      uploadEndpoint: '',
      variantId: null,
      basePrice: 0,
      maxFileSize: 25 * 1024 * 1024,
      allowedTypes: ['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml'],
    },
    printAreaRect: null,
    userImageObj: null,
    bgImageObj: null,
    bgAspectRatio: 1.2,
    isUploading: false,
  };

  // ══════════════════════════════════
  //  INIT
  // ══════════════════════════════════
  function init() {
    var el = document.getElementById('personalizer');
    if (!el) return;

    readConfig(el);
    loadData();

    if (state.colorsList.length === 0) return;

    // Insertar canvas dentro del grid de Dawn (columna izquierda)
    positionInDawnGrid();

    // El modal de vista previa va directo en <body>: dentro de la columna
    // (sticky en Concept) queda atrapado en su stacking context y la ficha
    // del producto se dibuja encima aunque tenga z-index alto.
    var previewOverlay = document.getElementById('pz-preview-overlay');
    if (previewOverlay && previewOverlay.parentNode !== document.body) {
      document.body.appendChild(previewOverlay);
    }

    setupCanvas();
    detectCurrentColor();
    listenVariantChange();
    bindEvents();

    filterViewsByColor(state.currentColor);
    updateStampVariant(); // Seleccionar variante con 0 estampados al inicio
  }

  // ══════════════════════════════════
  //  BLOQUEAR / DESBLOQUEAR BOTÓN CARRO
  // ══════════════════════════════════
  function blockCartButton(msg) {
    var btn = document.querySelector(CART_BUTTON_SELECTOR);
    if (!btn) return;
    btn.disabled = true;
    btn.classList.add('pz-cart-blocked');
    // Concept re-renderiza el precio DENTRO del botón: no reemplazar su contenido
    // (al restaurarlo volvería el precio viejo). Solo se bloquea.
    if (window.theme && theme.pubsub) return;
    btn.dataset.pzOrigHtml = btn.dataset.pzOrigHtml || btn.innerHTML;
    btn.textContent = msg || 'Actualizando...';
  }

  function unblockCartButton() {
    var btn = document.querySelector(CART_BUTTON_SELECTOR);
    if (!btn) return;
    btn.disabled = false;
    btn.classList.remove('pz-cart-blocked');
    if (window.theme && theme.pubsub) return;
    if (btn.dataset.pzOrigHtml) btn.innerHTML = btn.dataset.pzOrigHtml;
    delete btn.dataset.pzOrigHtml;
  }

  function readConfig(el) {
    var ds = el.dataset;
    state.config.stampPrice = parseFloat(ds.stampPrice) || 0;
    state.config.currency = ds.currency || '$';
    state.config.uploadEndpoint = ds.uploadEndpoint || '';
    state.config.variantId = ds.variantId || null;
    state.config.basePrice = parseFloat(ds.basePrice) || 0;
    state.config.canvasMaxWidth = parseInt(ds.canvasMaxWidth) || 1200;
    CANVAS_MAX_WIDTH = state.config.canvasMaxWidth;
  }

  function loadData() {
    try { state.viewsByColor = JSON.parse(document.getElementById('pz-views-by-color').textContent); } catch (e) { state.viewsByColor = {}; }
    try { state.colorsList = JSON.parse(document.getElementById('pz-colors-list').textContent); } catch (e) { state.colorsList = []; }
  }

  // ══════════════════════════════════
  //  POSICIONAR EN GRID DE DAWN
  // ══════════════════════════════════
  function positionInDawnGrid() {
    var personalizer = document.getElementById('personalizer');
    if (!personalizer) return;

    // Intentar Minimog primero
    var minimogMedia = document.querySelector('.m-main-product--media');
    if (minimogMedia) {
      // Mostrar columna media (estaba oculta por CSS)
      minimogMedia.style.display = 'block';
      // Ocultar contenido original de la galería
      var mediaContent = minimogMedia.querySelectorAll('.m-product-media--wrapper, .m-product-media--desktop, .m-product-media--mobile');
      mediaContent.forEach(function(el) { el.style.display = 'none'; });
      // Mover personalizador dentro de la columna media
      minimogMedia.appendChild(personalizer);
      personalizer.classList.add('personalizer--in-grid');
      // Ocultar la sección original (ya vacía)
      var origSection = personalizer.closest ? null : document.querySelector('section.personalizer-section');
      var sections = document.querySelectorAll('section.personalizer-section');
      sections.forEach(function(s) { if (!s.contains(personalizer)) s.style.display = 'none'; });
      return;
    }

    // Concept: columna .product__gallery-container. La media-gallery interna la
    // re-renderiza el tema al cambiar variante, así que el personalizador va como
    // hermano (no adentro) y la galería se oculta por CSS (.pz-concept).
    var conceptGallery = document.querySelector('product-info .product__gallery-container')
      || document.querySelector('.product__gallery-container');
    if (conceptGallery) {
      document.documentElement.classList.add('pz-concept');
      conceptGallery.insertBefore(personalizer, conceptGallery.firstChild);
      personalizer.classList.add('personalizer--in-grid');
      document.querySelectorAll('section.personalizer-section, .personalizer-section').forEach(function (s) {
        if (!s.contains(personalizer)) s.style.display = 'none';
      });
      return;
    }

    // Dawn: grid .product con 2 columnas
    var dawnGrid = document.querySelector('.product');
    var mediaWrapper = document.querySelector('.product__media-wrapper');
    if (dawnGrid && mediaWrapper) {
      dawnGrid.insertBefore(personalizer, mediaWrapper.nextSibling);
      personalizer.classList.add('personalizer--in-grid');
    }
  }

  // ══════════════════════════════════
  //  CANVAS
  // ══════════════════════════════════
  function setupCanvas() {
    var container = document.getElementById('pz-canvas-container');
    if (!container) return;

    var w = Math.min(container.offsetWidth || CANVAS_MAX_WIDTH, CANVAS_MAX_WIDTH);
    var h = Math.round(w * 1.2); // aspect ratio inicial, se ajusta al cargar imagen

    state.canvas = new fabric.Canvas('pz-canvas', {
      width: w,
      height: h,
      backgroundColor: '#f0f0f0',
      selection: false,
      enableRetinaScaling: true,
    });

    window.addEventListener('resize', debounce(handleResize, 300));
  }

  function handleResize() {
    var container = document.getElementById('pz-canvas-container');
    if (!container || !state.canvas) return;

    var newW = Math.min(container.offsetWidth || CANVAS_MAX_WIDTH, CANVAS_MAX_WIDTH);
    if (Math.abs(newW - state.canvas.getWidth()) < 10) return;

    var ratioW = newW / state.canvas.getWidth();
    // Mantener aspect ratio basado en la imagen de fondo
    var aspectRatio = state.bgAspectRatio || 1.2;
    var newH = Math.round(newW * aspectRatio);
    var ratioH = newH / state.canvas.getHeight();

    state.canvas.setWidth(newW);
    state.canvas.setHeight(newH);

    state.canvas.getObjects().forEach(function (obj) {
      obj.set({
        left: obj.left * ratioW,
        top: obj.top * ratioH,
        scaleX: obj.scaleX * ratioW,
        scaleY: obj.scaleY * ratioH,
      });
      obj.setCoords();
    });

    state.canvas.renderAll();
  }

  // ══════════════════════════════════
  //  DETECCIÓN DE COLOR EN DAWN
  // ══════════════════════════════════
  function detectCurrentColor() {
    var color = readDawnColor();
    if (color) {
      state.currentColor = color;
    } else if (state.colorsList.length > 0) {
      state.currentColor = state.colorsList[0];
    }
  }

  function readDawnColor() {
    // Método 1: input radio checked con name="Color" o similar
    var inputs = document.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < inputs.length; i++) {
      var name = (inputs[i].name || '').toLowerCase().trim();
      if (name === 'color' || name === 'colour' || name.indexOf('color') === 0) {
        return inputs[i].value;
      }
    }

    // Método 2: Buscar en fieldsets de Dawn y Minimog
    var fieldsets = document.querySelectorAll('fieldset.product-form__input, .m-product-option, .product-form__option');
    for (var j = 0; j < fieldsets.length; j++) {
      var legend = fieldsets[j].querySelector('legend, .m-product-option--title, label, .option-title');
      if (legend) {
        var text = legend.textContent || '';
        if (text.toLowerCase().indexOf('color') !== -1) {
          var checked = fieldsets[j].querySelector('input:checked');
          if (checked) return checked.value;
        }
      }
    }

    // Método 3: URL params
    var params = new URLSearchParams(window.location.search);
    var variant = params.get('variant');
    if (variant) {
      try {
        var variants = JSON.parse(document.getElementById('pz-variants-data').textContent);
        for (var k = 0; k < variants.length; k++) {
          if (String(variants[k].id) === String(variant)) {
            // Buscar el option que coincida con un color conocido
            for (var o = 0; o < variants[k].options.length; o++) {
              if (state.colorsList.indexOf(variants[k].options[o]) !== -1) {
                return variants[k].options[o];
              }
            }
          }
        }
      } catch (e) {}
    }

    return null;
  }

  function listenVariantChange() {
    // Ocultar selector de estampados
    hideStampSelector();

    // Escuchar cambios en inputs de variante (Dawn + Minimog + genérico)
    // Delegado en document: temas como Concept reemplazan el HTML del selector
    // de variantes en cada cambio y los listeners por input se perderían.
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.type !== 'radio') return;
      if (!input.closest('fieldset.product-form__input, .m-product-option, .product-form__option')) return;
      // Ignorar si el cambio fue provocado por updateStampVariant
      if (state.isUpdatingStamp) return;

      var newColor = readDawnColor();
      if (newColor && newColor !== state.currentColor) {
        saveCurrentStamp();
        state.currentColor = newColor;
        filterViewsByColor(newColor);
      }

      // Actualizar variant ID después de que Dawn procese el cambio
      setTimeout(function () {
        syncVariantFromDawn();
      }, 200);
    }, true);

    // Concept: al terminar de re-renderizar publica variantChange. El tema elige la
    // variante con el radio de estampados que él conoce (puede estar desfasado),
    // así que se re-aplica la cantidad real de estampados.
    if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS && theme.pubsub.PUB_SUB_EVENTS.variantChange) {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function (ev) {
        var newColor = readDawnColor();
        if (newColor && newColor !== state.currentColor) {
          saveCurrentStamp();
          state.currentColor = newColor;
          filterViewsByColor(newColor);
        }
        if (state.isUpdatingStamp) {
          // Este re-render lo pidió el personalizador (click en "estampados"): listo.
          state.isUpdatingStamp = false;
          clearTimeout(state.stampTimer);
          if (!state.isUploading) unblockCartButton();
          return;
        }
        setTimeout(updateStampVariant, 50);
      });
    }

    // Fallback: observer en URL
    var lastUrl = location.href;
    setInterval(function () {
      if (location.href !== lastUrl) {
        lastUrl = location.href;
        var newColor = readDawnColor();
        if (newColor && newColor !== state.currentColor) {
          saveCurrentStamp();
          state.currentColor = newColor;
          filterViewsByColor(newColor);
        }
      }
    }, 500);
  }

  // ══════════════════════════════════
  //  OCULTAR SELECTOR DE ESTAMPADOS
  // ══════════════════════════════════
  function hideStampSelector() {
    // Buscar en Dawn (fieldset.product-form__input) y Minimog (.m-product-option)
    var selectors = [
      'fieldset.product-form__input',
      '.m-product-option',
      '.product-form__option',
      '[data-option-index]'
    ];
    var allContainers = document.querySelectorAll(selectors.join(','));

    allContainers.forEach(function (fs) {
      var labelEl = fs.querySelector('legend, .m-product-option--title, label, .option-title, .product-form__option-title');
      if (labelEl) {
        var text = (labelEl.textContent || '').toLowerCase().trim();
        if (text.indexOf('estampado') !== -1) {
          fs.style.display = 'none';
          state.stampFieldset = fs;

          // Observer para re-ocultar si el tema lo vuelve a mostrar
          if (!state.stampObserver) {
            var parent = fs.parentElement;
            if (parent) {
              state.stampObserver = new MutationObserver(function () {
                var recheck = document.querySelectorAll(selectors.join(','));
                recheck.forEach(function (f) {
                  var leg = f.querySelector('legend, .m-product-option--title, label, .option-title, .product-form__option-title');
                  if (leg) {
                    var t = (leg.textContent || '').toLowerCase().trim();
                    if (t.indexOf('estampado') !== -1) {
                      f.style.display = 'none';
                      state.stampFieldset = f;
                    }
                  }
                });
              });
              state.stampObserver.observe(parent, { childList: true, subtree: true });
            }
          }
        }
      }
    });
  }

  // ══════════════════════════════════
  //  SINCRONIZAR VARIANTE CON ESTAMPADOS
  // ══════════════════════════════════
  // Concept: el selector de variantes lo maneja el tema (re-renderiza precio,
  // botón, sticky y variant id por AJAX). En vez de cambiar el id "por debajo",
  // se clickea el radio oculto de "estampados" para que el tema haga todo.
  function updateStampVariantConcept(count) {
    var fs = document.querySelector('product-info [data-option-slug*="estampado"]')
      || document.querySelector('[data-option-slug*="estampado"]');
    if (!fs) return false;
    var target = null;
    fs.querySelectorAll('input[type="radio"]').forEach(function (r) {
      if (String(r.value) === String(count)) target = r;
    });
    if (!target) return false;
    if (!target.checked) {
      state.isUpdatingStamp = true;
      target.click();
      clearTimeout(state.stampTimer);
      state.stampTimer = setTimeout(function () { state.isUpdatingStamp = false; }, 1500);
    }
    return true;
  }

  function updateStampVariant() {
    var count = getStampCount();
    console.log('[PZ] updateStampVariant count:', count);

    if (window.theme && theme.pubsub && updateStampVariantConcept(count)) return;

    // Método 1: Cambiar variant ID directamente (evita errores en Minimog y otros temas)
    var changed = changeVariantDirectly(count);

    // Método 2: Fallback - click en radio button (para Dawn)
    if (!changed && state.stampFieldset) {
      var inputs = state.stampFieldset.querySelectorAll('input[type="radio"]');
      var found = false;
      inputs.forEach(function (input) {
        if (String(input.value) === String(count)) {
          found = true;
          if (!input.checked) {
            console.log('[PZ] Cambiando estampados via click a:', count);
            state.isUpdatingStamp = true;
            input.click();
            setTimeout(function () { state.isUpdatingStamp = false; }, 500);
          }
        }
      });
      if (!found) {
        console.log('[PZ] No se encontró input para count:', count);
      }
    } else if (!changed) {
      console.log('[PZ] No stampFieldset encontrado');
    }

    // Re-ocultar selector de estampados
    setTimeout(function () { hideStampSelector(); }, 300);
    setTimeout(function () { hideStampSelector(); }, 600);
    setTimeout(function () { hideStampSelector(); }, 1000);
  }

  function changeVariantDirectly(stampCount) {
    try {
      var variantsData = JSON.parse(document.getElementById('pz-variants-data').textContent);

      // Leer color y talla actuales de los radio buttons
      var currentColor = readDawnColor();
      var currentTalla = null;
      var inputs = document.querySelectorAll('input[type="radio"]:checked');
      for (var i = 0; i < inputs.length; i++) {
        var name = (inputs[i].name || '').toLowerCase().trim();
        if (name.indexOf('talla') !== -1 || name.indexOf('size') !== -1) {
          currentTalla = inputs[i].value;
          break;
        }
      }

      if (!currentColor || !currentTalla) return false;

      // Buscar la variante que coincida con color + talla + estampados
      var target = null;
      for (var j = 0; j < variantsData.length; j++) {
        var v = variantsData[j];
        var opts = v.options || [];
        // Probar todas las combinaciones de posición de opciones
        var matchTalla = opts.indexOf(currentTalla) !== -1;
        var matchColor = opts.indexOf(currentColor) !== -1;
        var matchStamp = opts.indexOf(String(stampCount)) !== -1;
        if (matchTalla && matchColor && matchStamp) {
          target = v;
          break;
        }
      }

      if (!target) {
        console.log('[PZ] No se encontró variante para:', currentTalla, currentColor, stampCount);
        return false;
      }

      console.log('[PZ] Cambiando variant ID directamente a:', target.id, target.options);

      // Cambiar todos los inputs de variant ID
      document.querySelectorAll('input[name="id"], select[name="id"]').forEach(function (inp) {
        inp.value = target.id;
      });

      // Marcar el radio de estampados como checked (sin disparar eventos)
      if (state.stampFieldset) {
        var radios = state.stampFieldset.querySelectorAll('input[type="radio"]');
        radios.forEach(function (r) { r.checked = String(r.value) === String(stampCount); });
      }

      // Actualizar precio en la página
      updatePriceDisplay(target.price);

      // Actualizar URL sin recargar
      var url = new URL(window.location);
      url.searchParams.set('variant', target.id);
      window.history.replaceState({}, '', url);

      state.config.variantId = String(target.id);
      state.config.basePrice = target.price;

      return true;
    } catch (e) {
      console.log('[PZ] Error en changeVariantDirectly:', e.message);
      return false;
    }
  }

  function updatePriceDisplay(priceInCents) {
    // Formatear precio (Shopify guarda en centavos para algunas monedas, o en unidad)
    var formatted = '$' + priceInCents.toLocaleString('es-CL') + ' CLP';

    // Concept: precio principal + precio dentro del botón y del botón sticky
    var conceptPrices = document.querySelectorAll('.product__price .price__regular, product-buy-price');
    if (conceptPrices.length) {
      var useComma = /\d,\d{3}/.test(conceptPrices[0].textContent || '');
      var fm = '$' + Math.round(priceInCents).toLocaleString(useComma ? 'en-US' : 'es-CL');
      conceptPrices.forEach(function (el) { el.textContent = fm; });
      return;
    }

    // Buscar elementos de precio en diferentes temas
    var priceSelectors = [
      '.m-price-item--regular',        // Minimog
      '.price-item--regular',           // Dawn
      '.product-price',                 // Genérico
      '.m-product-price .money',        // Minimog alt
      'sale-price .money',              // Minimog sale
    ];

    for (var i = 0; i < priceSelectors.length; i++) {
      var el = document.querySelector(priceSelectors[i]);
      if (el) {
        el.textContent = formatted;
        console.log('[PZ] Precio actualizado a:', formatted);
        break;
      }
    }
  }

  function syncVariantFromDawn() {
    var params = new URLSearchParams(window.location.search);
    var vid = params.get('variant');
    if (vid) {
      state.config.variantId = vid;
      try {
        var variants = JSON.parse(document.getElementById('pz-variants-data').textContent);
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(vid)) {
            state.config.basePrice = variants[i].price;
            break;
          }
        }
      } catch (e) {}
    }
  }

  // ══════════════════════════════════
  //  FILTRAR VISTAS POR COLOR
  // ══════════════════════════════════
  function filterViewsByColor(color) {
    state.currentViews = state.viewsByColor[color] || [];
    state.currentViewIndex = 0;

    buildTabs();

    if (state.currentViews.length > 0) {
      loadView(0);
    } else {
      state.canvas.clear();
      state.canvas.renderAll();
    }

    updateSummary();
    updateStampVariant();
  }

  // ══════════════════════════════════
  //  TABS
  // ══════════════════════════════════
  function buildTabs() {
    var tabsEl = document.getElementById('pz-tabs');
    if (!tabsEl) return;

    var html = '';
    state.currentViews.forEach(function (view, i) {
      html += '<button type="button" class="personalizer__tab' +
        (i === 0 ? ' personalizer__tab--active' : '') +
        '" data-view-index="' + i + '">' + escapeHtml(view.name) + '</button>';
    });
    tabsEl.innerHTML = html;
  }

  function switchView(index) {
    if (index === state.currentViewIndex && state.bgImageObj) return;

    saveCurrentStamp();
    state.currentViewIndex = index;

    document.querySelectorAll('.personalizer__tab').forEach(function (tab) {
      tab.classList.toggle('personalizer__tab--active', parseInt(tab.dataset.viewIndex) === index);
    });

    loadView(index);
    updateSummary();
    updateStampVariant();
  }

  // ══════════════════════════════════
  //  CARGAR VISTA
  // ══════════════════════════════════
  function loadView(index) {
    var view = state.currentViews[index];
    if (!view) return;

    var canvas = state.canvas;
    canvas.clear();
    state.printAreaRect = null;
    state.userImageObj = null;
    state.bgImageObj = null;

    // Label
    var label = document.getElementById('pz-side-label');
    if (label) label.textContent = view.name.toUpperCase();

    // Cargar imagen de fondo
    if (view.image) {
      loadBackgroundImage(view.image, function () {
        drawPrintArea(view);
        restoreStamp(view.name);
        updateDeleteButton();
      });
    } else {
      drawPrintArea(view);
      restoreStamp(view.name);
      updateDeleteButton();
    }

    hideMeasure();
    hideGuides();
  }

  function loadBackgroundImage(url, callback) {
    var canvas = state.canvas;

    fabric.Image.fromURL(url, function (img) {
      if (!img || !img.width) {
        if (callback) callback();
        return;
      }

      var canvasW = canvas.getWidth();
      var canvasH = canvas.getHeight();
      var scale = Math.min(canvasW / img.width, canvasH / img.height);

      img.set({
        left: canvasW / 2,
        top: canvasH / 2,
        originX: 'center',
        originY: 'center',
        scaleX: scale,
        scaleY: scale,
        selectable: false,
        evented: false,
        excludeFromExport: false,
        isBgImage: true,
      });

      canvas.add(img);
      canvas.sendToBack(img);
      state.bgImageObj = img;
      canvas.renderAll();

      // Ajustar canvas height al aspect ratio de la imagen
      state.bgAspectRatio = img.height / img.width;

      // Calcular realHeightCm por proporción de la imagen
      var currentView = state.currentViews[state.currentViewIndex];
      if (currentView) {
        currentView.realHeightCm = currentView.realWidthCm * state.bgAspectRatio;
      }

      var newH = Math.round(canvasW * state.bgAspectRatio);
      if (Math.abs(newH - canvasH) > 5) {
        canvas.setHeight(newH);
        img.set({ top: newH / 2, scaleX: canvasW / img.width, scaleY: canvasW / img.width });
        img.setCoords();
        canvas.renderAll();
      }

      if (callback) callback();
    }, { crossOrigin: 'anonymous' });
  }

  // ══════════════════════════════════
  //  ÁREA DE IMPRESIÓN
  // ══════════════════════════════════
  function drawPrintArea(view) {
    var canvas = state.canvas;
    var w = canvas.getWidth();
    var h = canvas.getHeight();
    var pa = view.printArea;

    var rect = new fabric.Rect({
      left: (pa.x / 100) * w,
      top: (pa.y / 100) * h,
      width: (pa.w / 100) * w,
      height: (pa.h / 100) * h,
      fill: 'rgba(255,255,255,0.05)',
      stroke: 'rgba(52,152,219,0.7)',
      strokeWidth: 2,
      strokeDashArray: [8, 4],
      selectable: false,
      evented: false,
      excludeFromExport: true,
      isPrintArea: true,
    });

    canvas.add(rect);
    state.printAreaRect = rect;
    canvas.renderAll();
  }

  function getPrintAreaPx() {
    var view = state.currentViews[state.currentViewIndex];
    if (!view) return { x: 0, y: 0, w: 100, h: 100 };
    var cw = state.canvas.getWidth();
    var ch = state.canvas.getHeight();
    var pa = view.printArea;
    return {
      x: (pa.x / 100) * cw,
      y: (pa.y / 100) * ch,
      w: (pa.w / 100) * cw,
      h: (pa.h / 100) * ch,
    };
  }

  // ══════════════════════════════════
  //  GUARDAR / RESTAURAR ESTAMPADOS
  // ══════════════════════════════════
  function saveCurrentStamp() {
    var view = state.currentViews[state.currentViewIndex];
    if (!view) return;
    var loc = view.name;

    if (state.userImageObj) {
      var existing = state.stampsByLocation[loc] || {};
      state.stampsByLocation[loc] = {
        dataUrl: existing.dataUrl || null,
        fileName: existing.fileName || null,
        originalWidth: existing.originalWidth || state.userImageObj.width,
        originalHeight: existing.originalHeight || state.userImageObj.height,
        widthCm: pxToCm(state.userImageObj.getBoundingRect().width, 'w'),
        heightCm: pxToCm(state.userImageObj.getBoundingRect().height, 'h'),
        position: {
          left: state.userImageObj.left,
          top: state.userImageObj.top,
          scaleX: state.userImageObj.scaleX,
          scaleY: state.userImageObj.scaleY,
          angle: state.userImageObj.angle,
        },
      };
    }
  }

  function restoreStamp(locationName) {
    var stamp = state.stampsByLocation[locationName];
    if (!stamp || !stamp.dataUrl) return;

    var area = getPrintAreaPx();

    fabric.Image.fromURL(stamp.dataUrl, function (img) {
      var pos = stamp.position || {};

      img.set({
        left: pos.left || (area.x + area.w / 2),
        top: pos.top || (area.y + area.h / 2),
        originX: 'center',
        originY: 'center',
        scaleX: pos.scaleX || 1,
        scaleY: pos.scaleY || 1,
        angle: pos.angle || 0,
        lockUniScaling: true,
        lockScalingFlip: true,
        cornerColor: '#3498db',
        cornerStrokeColor: '#2980b9',
        cornerSize: 12,
        transparentCorners: false,
        borderColor: '#3498db',
        borderScaleFactor: 2,
        isUserImage: true,
      });

      img.setControlsVisibility({
        mt: false, mb: false, ml: false, mr: false,
        tl: true, tr: true, bl: true, br: true,
        mtr: true,
      });

      state.canvas.add(img);
      state.userImageObj = img;
      state.canvas.setActiveObject(img);
      state.canvas.renderAll();
      updateMeasure(img);
      updateDeleteButton();
    });
  }

  // ══════════════════════════════════
  //  SUBIDA DE IMAGEN DEL USUARIO
  // ══════════════════════════════════
  function handleFileUpload(e) {
    var files = e.target.files;
    if (!files || !files.length) return;
    var file = files[0];

    if (state.config.allowedTypes.indexOf(file.type) === -1) {
      showMessage('Formato no soportado. Usa PNG, JPG o WebP.', 'error');
      e.target.value = '';
      return;
    }
    if (file.size > state.config.maxFileSize) {
      showMessage('Imagen muy grande. Máximo 25MB.', 'error');
      e.target.value = '';
      return;
    }

    var reader = new FileReader();
    reader.onload = function (ev) {
      addImageToCanvas(ev.target.result, file.name);
    };
    reader.readAsDataURL(file);
    e.target.value = '';
  }

  function addImageToCanvas(dataUrl, fileName) {
    var canvas = state.canvas;
    var view = state.currentViews[state.currentViewIndex];
    if (!view) return;

    var area = getPrintAreaPx();

    // Eliminar imagen anterior si hay
    if (state.userImageObj) {
      canvas.remove(state.userImageObj);
      state.userImageObj = null;
    }

    fabric.Image.fromURL(dataUrl, function (img) {
      var maxWPx = cmToPx(view.maxStampWCm, 'w');
      var maxHPx = cmToPx(view.maxStampHCm, 'h');
      var fitW = Math.min(area.w * 0.8, maxWPx);
      var fitH = Math.min(area.h * 0.8, maxHPx);
      var scale = Math.min(fitW / img.width, fitH / img.height, 1);

      img.set({
        left: area.x + area.w / 2,
        top: area.y + area.h / 2,
        originX: 'center',
        originY: 'center',
        scaleX: scale,
        scaleY: scale,
        lockUniScaling: true,
        lockScalingFlip: true,
        cornerColor: '#3498db',
        cornerStrokeColor: '#2980b9',
        cornerSize: 12,
        transparentCorners: false,
        borderColor: '#3498db',
        borderScaleFactor: 2,
        isUserImage: true,
      });

      // Ocultar controles laterales (solo esquinas para mantener aspect ratio)
      img.setControlsVisibility({
        mt: false, mb: false, ml: false, mr: false,
        tl: true, tr: true, bl: true, br: true,
        mtr: true,
      });

      // Calcular escala máxima que cabe en el área (sin rotación)
      var maxScaleByArea = Math.min(area.w / img.width, area.h / img.height);
      var maxScaleByCm = Infinity;
      if (view.maxStampWCm) maxScaleByCm = Math.min(maxScaleByCm, cmToPx(view.maxStampWCm, 'w') / img.width);
      if (view.maxStampHCm) maxScaleByCm = Math.min(maxScaleByCm, cmToPx(view.maxStampHCm, 'h') / img.height);
      img._maxScale = Math.min(maxScaleByArea, maxScaleByCm) * 0.99;

      canvas.add(img);
      canvas.setActiveObject(img);
      state.userImageObj = img;

      // Guardar datos
      var wCm = pxToCm(img.getScaledWidth(), 'w');
      var hCm = pxToCm(img.getScaledHeight(), 'h');

      state.stampsByLocation[view.name] = {
        dataUrl: dataUrl,
        fileName: fileName,
        widthCm: wCm,
        heightCm: hCm,
        originalWidth: img.width,
        originalHeight: img.height,
        position: {
          left: img.left,
          top: img.top,
          scaleX: img.scaleX,
          scaleY: img.scaleY,
          angle: img.angle,
        },
      };

      canvas.renderAll();
      updateMeasure(img);
      updateDeleteButton();
      updateSummary();

      // Bloquear carrito y esperar que Dawn actualice la variante
      blockCartButton('Actualizando precio...');
      updateStampVariant();
      setTimeout(function () { unblockCartButton(); }, 1500);
    });
  }

  // ══════════════════════════════════
  //  MEDIDAS CM ↔ PX
  // ══════════════════════════════════
  function pxToCm(px, axis) {
    var view = state.currentViews[state.currentViewIndex];
    if (!view) return 0;
    var cw = state.canvas.getWidth();
    var ch = state.canvas.getHeight();
    return axis === 'w'
      ? (px / cw) * view.realWidthCm
      : (px / ch) * view.realHeightCm;
  }

  function cmToPx(cm, axis) {
    var view = state.currentViews[state.currentViewIndex];
    if (!view) return 0;
    var cw = state.canvas.getWidth();
    var ch = state.canvas.getHeight();
    return axis === 'w'
      ? (cm / view.realWidthCm) * cw
      : (cm / view.realHeightCm) * ch;
  }

  function updateMeasure(obj) {
    if (!obj || !obj.isUserImage) { hideMeasure(); return; }
    // Usar bounding rect para considerar rotación
    obj.setCoords();
    var br = obj.getBoundingRect();
    var wCm = pxToCm(br.width, 'w');
    var hCm = pxToCm(br.height, 'h');

    var overlay = document.getElementById('pz-measure-overlay');
    var text = document.getElementById('pz-measure-text');
    if (overlay && text) {
      text.textContent = wCm.toFixed(1) + ' x ' + hCm.toFixed(1) + ' cm';
      overlay.style.display = 'flex';

      // Posicionar debajo de la imagen
      var container = document.getElementById('pz-canvas-container');
      if (container) {
        var cRect = container.getBoundingClientRect();
        var canvasEl = state.canvas.getElement();
        var cElRect = canvasEl.getBoundingClientRect();
        var sx = cElRect.width / state.canvas.getWidth();
        var sy = cElRect.height / state.canvas.getHeight();
        var offsetX = cElRect.left - cRect.left;
        var offsetY = cElRect.top - cRect.top;

        overlay.style.left = (offsetX + obj.left * sx) + 'px';
        overlay.style.top = (offsetY + (obj.top + obj.getScaledHeight() / 2 + 10) * sy) + 'px';
      }
    }
  }

  function hideMeasure() {
    var o = document.getElementById('pz-measure-overlay');
    if (o) o.style.display = 'none';
  }

  // ══════════════════════════════════
  //  LÍMITES DE TAMAÑO
  // ══════════════════════════════════
  function enforceMaxSize(obj) {
    if (!obj || !obj.isUserImage) return;
    var view = state.currentViews[state.currentViewIndex];
    if (!view) return;

    var wCm = pxToCm(obj.getScaledWidth(), 'w');
    var hCm = pxToCm(obj.getScaledHeight(), 'h');
    var s = obj.scaleX;
    var clamped = false;

    if (wCm > view.maxStampWCm) {
      s = cmToPx(view.maxStampWCm, 'w') / obj.width;
      clamped = true;
    }
    if (hCm > view.maxStampHCm) {
      var sh = cmToPx(view.maxStampHCm, 'h') / obj.height;
      if (sh < s) s = sh;
      clamped = true;
    }
    if (clamped) {
      obj.set({ scaleX: s, scaleY: s });
      obj.setCoords();
    }
  }

  // ══════════════════════════════════
  //  LIMITAR IMAGEN AL ÁREA DE IMPRESIÓN
  // ══════════════════════════════════
  function clampToPrintArea(obj) {
    if (!obj || !obj.isUserImage) return;
    var area = getPrintAreaPx();

    // Usar bounding rect que considera rotación
    var br = obj.getBoundingRect();
    var bw = br.width / 2;
    var bh = br.height / 2;

    // Calcular offset entre centro del objeto y centro del bounding rect
    var brCenterX = br.left + br.width / 2;
    var brCenterY = br.top + br.height / 2;
    var offsetX = obj.left - brCenterX;
    var offsetY = obj.top - brCenterY;

    // Si el bounding rect es más grande que el área, centrar
    if (br.width > area.w) {
      obj.set('left', area.x + area.w / 2 + offsetX);
    } else {
      var minX = area.x + bw + offsetX;
      var maxX = area.x + area.w - bw + offsetX;
      if (obj.left < minX) obj.set('left', minX);
      if (obj.left > maxX) obj.set('left', maxX);
    }

    if (br.height > area.h) {
      obj.set('top', area.y + area.h / 2 + offsetY);
    } else {
      var minY = area.y + bh + offsetY;
      var maxY = area.y + area.h - bh + offsetY;
      if (obj.top < minY) obj.set('top', minY);
      if (obj.top > maxY) obj.set('top', maxY);
    }

    obj.setCoords();
  }

  function clampScaleToPrintArea(obj) {
    if (!obj || !obj.isUserImage) return;
    // Solo re-centrar si se sale del área (la escala se limita via _maxScale en object:scaling)
    clampToPrintArea(obj);
  }

  function fitBoundingBoxToArea(obj) {
    if (!obj || !obj.isUserImage) return;
    var area = getPrintAreaPx();

    // Calcular bounding box con la rotación actual
    obj.setCoords();
    var br = obj.getBoundingRect();

    // Si el bounding box excede el área, reducir escala
    if (br.width > area.w || br.height > area.h) {
      var scaleRatio = Math.min(area.w / br.width, area.h / br.height);
      var newScale = obj.scaleX * scaleRatio * 0.95; // 95% para dar margen
      obj.set({ scaleX: newScale, scaleY: newScale });
      obj.setCoords();
    }

    // También verificar límites en cm
    var view = state.currentViews[state.currentViewIndex];
    if (view) {
      obj.setCoords();
      var newBr = obj.getBoundingRect();
      var bbWCm = pxToCm(newBr.width, 'w');
      var bbHCm = pxToCm(newBr.height, 'h');

      if (bbWCm > view.maxStampWCm || bbHCm > view.maxStampHCm) {
        var cmRatio = Math.min(view.maxStampWCm / bbWCm, view.maxStampHCm / bbHCm);
        obj.set({ scaleX: obj.scaleX * cmRatio, scaleY: obj.scaleY * cmRatio });
        obj.setCoords();
      }
    }

    clampToPrintArea(obj);
  }

  // ══════════════════════════════════
  //  SNAPPING
  // ══════════════════════════════════
  function applySnapping(obj) {
    var area = getPrintAreaPx();
    var cx = area.x + area.w / 2;
    var cy = area.y + area.h / 2;
    var hw = obj.getScaledWidth() / 2;
    var hh = obj.getScaledHeight() / 2;
    var ox = obj.left;
    var oy = obj.top;
    var sx = false, sy = false;

    // Snap horizontal: centro, borde izq, borde der
    if (Math.abs(ox - cx) < SNAP_THRESHOLD) {
      obj.set('left', cx); sx = true; showGuide('v', cx);
    } else if (Math.abs((ox - hw) - area.x) < SNAP_THRESHOLD) {
      obj.set('left', area.x + hw); sx = true; showGuide('v', area.x);
    } else if (Math.abs((ox + hw) - (area.x + area.w)) < SNAP_THRESHOLD) {
      obj.set('left', area.x + area.w - hw); sx = true; showGuide('v', area.x + area.w);
    }

    // Snap vertical: centro, borde sup, borde inf
    if (Math.abs(oy - cy) < SNAP_THRESHOLD) {
      obj.set('top', cy); sy = true; showGuide('h', cy);
    } else if (Math.abs((oy - hh) - area.y) < SNAP_THRESHOLD) {
      obj.set('top', area.y + hh); sy = true; showGuide('h', area.y);
    } else if (Math.abs((oy + hh) - (area.y + area.h)) < SNAP_THRESHOLD) {
      obj.set('top', area.y + area.h - hh); sy = true; showGuide('h', area.y + area.h);
    }

    if (!sx) hideGuide('v');
    if (!sy) hideGuide('h');
  }

  function showGuide(axis, pos) {
    var el = document.getElementById('pz-guide-' + axis);
    if (!el) return;

    var canvasEl = state.canvas.getElement();
    var container = document.getElementById('pz-canvas-container');
    if (!canvasEl || !container) return;

    var cRect = container.getBoundingClientRect();
    var eRect = canvasEl.getBoundingClientRect();
    var sx = eRect.width / state.canvas.getWidth();
    var sy = eRect.height / state.canvas.getHeight();
    var offsetX = eRect.left - cRect.left;
    var offsetY = eRect.top - cRect.top;

    el.style.display = 'block';
    if (axis === 'h') {
      el.style.top = (offsetY + pos * sy) + 'px';
      el.style.left = offsetX + 'px';
      el.style.width = eRect.width + 'px';
      el.style.height = '1px';
    } else {
      el.style.left = (offsetX + pos * sx) + 'px';
      el.style.top = offsetY + 'px';
      el.style.height = eRect.height + 'px';
      el.style.width = '1px';
    }
  }

  function hideGuide(a) {
    var e = document.getElementById('pz-guide-' + a);
    if (e) e.style.display = 'none';
  }

  function hideGuides() { hideGuide('h'); hideGuide('v'); }

  // ══════════════════════════════════
  //  EVENTOS
  // ══════════════════════════════════
  function bindEvents() {
    var canvas = state.canvas;

    // Tabs
    document.getElementById('pz-tabs').addEventListener('click', function (e) {
      var tab = e.target.closest('.personalizer__tab');
      if (tab) switchView(parseInt(tab.dataset.viewIndex));
    });

    // Upload
    var uploadBtn = document.getElementById('pz-upload-btn');
    var fileInput = document.getElementById('pz-file-input');
    if (uploadBtn && fileInput) {
      uploadBtn.addEventListener('click', function () { fileInput.click(); });
      fileInput.addEventListener('change', handleFileUpload);
    }

    // Delete
    var deleteBtn = document.getElementById('pz-delete-btn');
    if (deleteBtn) deleteBtn.addEventListener('click', deleteCurrentImage);

    // Keyboard delete
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Delete' || e.key === 'Backspace') &&
          e.target.tagName !== 'INPUT' && e.target.tagName !== 'TEXTAREA' && e.target.tagName !== 'SELECT') {
        deleteCurrentImage();
      }
    });

    // Preview
    var previewBtn = document.getElementById('pz-preview-btn');
    if (previewBtn) previewBtn.addEventListener('click', showPreview);
    var closePreview = document.getElementById('pz-preview-close');
    if (closePreview) closePreview.addEventListener('click', hidePreview);
    var overlay = document.getElementById('pz-preview-overlay');
    if (overlay) overlay.addEventListener('click', function (e) { if (e.target === overlay) hidePreview(); });

    // Canvas events
    canvas.on('object:moving', function (e) {
      if (e.target.isUserImage) {
        applySnapping(e.target);
      }
    });

    canvas.on('object:scaling', function (e) {
      if (!e.target.isUserImage) return;
      var obj = e.target;
      enforceMaxSize(obj);
      updateMeasure(obj);
    });

    // Limitar escala: guardar última posición válida y restaurar si excede
    canvas.on('mouse:move', function () {
      var obj = canvas.getActiveObject();
      if (!obj || !obj.isUserImage || !obj._maxScale) return;
      if (obj.scaleX <= obj._maxScale) {
        // Guardar estado válido
        obj._lastGood = {
          scaleX: obj.scaleX,
          scaleY: obj.scaleY,
          left: obj.left,
          top: obj.top,
        };
      } else {
        // Restaurar último estado válido
        if (obj._lastGood) {
          obj.set({
            scaleX: obj._lastGood.scaleX,
            scaleY: obj._lastGood.scaleY,
            left: obj._lastGood.left,
            top: obj._lastGood.top,
          });
          obj.setCoords();
          canvas.requestRenderAll();
        }
      }
    });

    canvas.on('object:rotating', function (e) {
      if (!e.target.isUserImage) return;
      var angle = e.target.angle % 360;
      if (angle < 0) angle += 360;
      var snapAngles = [0, 45, 90, 135, 180, 225, 270, 315, 360];
      for (var i = 0; i < snapAngles.length; i++) {
        if (Math.abs(angle - snapAngles[i]) < 5) {
          e.target.set('angle', snapAngles[i] === 360 ? 0 : snapAngles[i]);
          break;
        }
      }
      // Ajustar escala para que el bounding box quepa en el área
      fitBoundingBoxToArea(e.target);
      updateMeasure(e.target);
    });

    canvas.on('object:modified', function (e) {
      if (!e.target.isUserImage) return;
      enforceMaxSize(e.target);
      clampToPrintArea(e.target);
      updateMeasure(e.target);
      hideGuides();
      // Actualizar posición guardada
      var view = state.currentViews[state.currentViewIndex];
      if (view && state.stampsByLocation[view.name]) {
        state.stampsByLocation[view.name].position = {
          left: e.target.left,
          top: e.target.top,
          scaleX: e.target.scaleX,
          scaleY: e.target.scaleY,
          angle: e.target.angle,
        };
      }
    });

    canvas.on('selection:created', function (e) {
      updateDeleteButton();
      if (e.selected && e.selected[0] && e.selected[0].isUserImage) {
        updateMeasure(e.selected[0]);
      }
    });

    canvas.on('selection:cleared', function () {
      updateDeleteButton();
      hideMeasure();
      hideGuides();
    });

    canvas.on('mouse:up', function () { hideGuides(); });

    // Interceptar botón de agregar al carro de Dawn
    interceptCartButton();
  }

  // ══════════════════════════════════
  //  INTERCEPTAR BOTÓN DE DAWN
  // ══════════════════════════════════
  // Concept: formulario principal del producto (el botón normal y el sticky
  // apuntan a él con el atributo form="ProductForm-...").
  function getConceptProductForm() {
    if (!(window.theme && theme.pubsub)) return null;
    return document.querySelector('product-info form[id^="ProductForm-"]');
  }

  // Agrega al carro usando el propio formulario del tema, con las propiedades
  // como inputs ocultos: así el tema refresca y abre su carro lateral.
  function submitViaThemeForm(form, cartData) {
    return new Promise(function (resolve) {
      var added = [];
      Object.keys(cartData.properties).forEach(function (k) {
        var inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'properties[' + k + ']';
        inp.value = cartData.properties[k];
        inp.setAttribute('data-pz-prop', '1');
        form.appendChild(inp);
        added.push(inp);
      });
      // El id de variante lo deja el propio tema (se eligió "estampados" por su
      // selector); solo se completa si viniera vacío.
      form.querySelectorAll('[name="id"]').forEach(function (inp) {
        if (!inp.value && cartData.id) inp.value = cartData.id;
      });

      var done = false;
      function finish(ok) {
        if (done) return;
        done = true;
        document.removeEventListener('ajaxProduct:added', onOk);
        document.removeEventListener('ajaxProduct:error', onErr);
        added.forEach(function (inp) { inp.remove(); });
        resolve({ ok: ok, viaTheme: true });
      }
      function onOk() { finish(true); }
      function onErr() { finish(false); }
      document.addEventListener('ajaxProduct:added', onOk);
      document.addEventListener('ajaxProduct:error', onErr);
      setTimeout(function () { finish(false); }, 20000);

      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  function interceptCartButton() {
    var conceptForm = getConceptProductForm();
    var submitBtns = [];
    if (conceptForm) {
      // getAttribute: el form tiene un <input name="id"> que tapa la propiedad form.id
      var formId = conceptForm.getAttribute('id');
      submitBtns = Array.prototype.slice.call(document.querySelectorAll(
        '[type="submit"][form="' + formId + '"], #' + formId + ' [type="submit"]'
      ));
    } else {
      var single = document.querySelector('product-form .product-form__submit')
        || document.querySelector('button.m-add-to-cart')
        || document.querySelector('.m-add-to-cart')
        || document.querySelector(CART_BUTTON_SELECTOR);
      if (single) submitBtns = [single];
    }
    if (!submitBtns.length) { console.log('[PZ] No se encontró botón de agregar al carro para interceptar'); return; }

    submitBtns.forEach(function (submitBtn) { submitBtn.addEventListener('click', onCartClick, true); });

    function onCartClick(e) {
      var stampCount = getStampCount();
      if (state.isUploading) return;
      if (stampCount === 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showMessage('Debes agregar al menos un estampado antes de agregar al carrito.', 'error');
        return;
      }

      // Prevenir que Dawn haga submit
      e.preventDefault();
      e.stopImmediatePropagation();

      state.isUploading = true;
      blockCartButton('Subiendo imágenes...');
      saveCurrentStamp();

      // Recoger estampados
      var stamped = [];
      Object.keys(state.stampsByLocation).forEach(function (loc) {
        var s = state.stampsByLocation[loc];
        if (s && s.dataUrl) {
          stamped.push({ location: loc, data: s });
        }
      });

      // Generar ID de diseño
      var designId = 'PZ-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).substring(2, 6).toUpperCase();

      // Subir imágenes al servidor
      var uploads = [];
      stamped.forEach(function (s) {
        if (state.config.uploadEndpoint) {
          uploads.push(
            uploadImage(s.data.dataUrl, s.data.fileName || 'estampado.png', designId, s.location)
              .then(function (r) { return { type: 'original', loc: s.location, url: r.url }; })
              .catch(function () { return { type: 'original', loc: s.location, url: null }; })
          );
          uploads.push(
            exportViewPreview(s.location).then(function (d) {
              return uploadImage(d, 'preview_' + s.location + '.png', designId, s.location);
            })
              .then(function (r) { return { type: 'preview', loc: s.location, url: r.url }; })
              .catch(function () { return { type: 'preview', loc: s.location, url: null }; })
          );
        }
      });

      var doUploads = (uploads.length > 0) ? Promise.all(uploads) : Promise.resolve(null);

      doUploads.then(function (results) {
        // Obtener variant ID actual de Dawn
        // En Concept el primer form /cart/add de la página es el de cuotas
        // (installment), que no siempre trae la variante vigente: leer del form
        // del producto, que el tema mantiene al día.
        var form = conceptForm || document.querySelector('form[action="/cart/add"]');
        var variantInput = form ? form.querySelector('[name="id"]') : null;
        var variantId = variantInput ? variantInput.value : state.config.variantId;

        // Construir data para /cart/add.js
        var cartData = {
          id: parseInt(variantId),
          quantity: 1,
          properties: {}
        };

        // Cantidad
        var qtyInput = document.querySelector('input[name="quantity"]');
        if (qtyInput) cartData.quantity = parseInt(qtyInput.value) || 1;

        // Propiedades del personalizer
        cartData.properties['_ID Diseño'] = designId;

        stamped.forEach(function (s) {
          var wCm = s.data.widthCm || 0;
          var hCm = s.data.heightCm || 0;
          cartData.properties['📍 ' + s.location] =
            (s.data.fileName || 'imagen') + ' | ' + wCm.toFixed(1) + 'x' + hCm.toFixed(1) + 'cm';

          if (s.data.position) {
            var cw = state.canvas.getWidth();
            var ch = state.canvas.getHeight();
            var xPct = Math.round((s.data.position.left / cw) * 100);
            var yPct = Math.round((s.data.position.top / ch) * 100);
            var wPct = Math.round((s.data.originalWidth * s.data.position.scaleX / cw) * 100);
            var hPct = Math.round((s.data.originalHeight * s.data.position.scaleY / ch) * 100);
            var angle = Math.round(s.data.position.angle || 0);
            cartData.properties['_Pos ' + s.location] = xPct + ',' + yPct + ',' + wPct + ',' + hPct + ',' + angle;
          }

          // Print area de esta vista (% del canvas): Tee lo usa para ubicar el
          // diseño exacto sin tener que conocer la configuración de cada tienda.
          var viewCfg = null;
          (state.currentViews || []).forEach(function (v) { if (v.name === s.location) viewCfg = v; });
          if (viewCfg && viewCfg.printArea) {
            var pa = viewCfg.printArea;
            cartData.properties['_Area ' + s.location] = pa.x + ',' + pa.y + ',' + pa.w + ',' + pa.h;
          }
        });

        if (results) {
          results.forEach(function (r) {
            if (r.url) {
              var label = (r.type === 'original' ? 'Archivo ' : 'Vista previa ') + r.loc;
              cartData.properties[label] = r.url;
            }
          });
        }

        if (conceptForm) return submitViaThemeForm(conceptForm, cartData);

        // Enviar directamente a Shopify
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(cartData),
        });
      }).then(function (res) {
        if (res && res.ok) {
          showMessage('¡Agregado al carro exitosamente!', 'success');
          // Actualizar burbuja del carro
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var bubble = document.querySelector('.cart-count-bubble span');
            if (bubble) bubble.textContent = cart.item_count;
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }).catch(function () {});
        } else {
          showMessage('Error al agregar al carro.', 'error');
        }
        state.isUploading = false;
        unblockCartButton();
        hideStampSelector();
      }).catch(function () {
        state.isUploading = false;
        showMessage('Error al procesar. Intenta de nuevo.', 'error');
        unblockCartButton();
      });
    } // onCartClick: registrado con useCapture = true para interceptar antes que el tema
  }

  function findViewByLocation(loc) {
    // Buscar en todas las vistas de todos los colores
    for (var color in state.viewsByColor) {
      var views = state.viewsByColor[color];
      for (var i = 0; i < views.length; i++) {
        if (views[i].name === loc) return views[i];
      }
    }
    return null;
  }

  function uploadImage(dataUrl, fileName, designId, location) {
    var endpoint = state.config.uploadEndpoint;
    if (!endpoint) return Promise.reject('No endpoint');

    var byteString = atob(dataUrl.split(',')[1]);
    var mimeType = dataUrl.split(',')[0].split(':')[1].split(';')[0];
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);
    var blob = new Blob([ab], { type: mimeType });

    var fd = new FormData();
    fd.append('image', blob, fileName);
    if (designId) fd.append('design_id', designId);
    if (location) fd.append('location', location);

    return fetch(endpoint, { method: 'POST', body: fd })
      .then(function (res) {
        if (!res.ok) throw new Error('Upload failed');
        return res.json();
      });
  }

  function exportViewPreview(locationName) {
    return new Promise(function (resolve) {
      // Encontrar la vista con esa ubicación para el color actual
      var view = null;
      if (state.currentViews) {
        for (var i = 0; i < state.currentViews.length; i++) {
          if (state.currentViews[i].name === locationName) {
            view = state.currentViews[i];
            break;
          }
        }
      }
      if (!view) view = findViewByLocation(locationName);

      var stamp = state.stampsByLocation[locationName];
      var baseCw = state.canvas.getWidth();
      var baseCh = state.canvas.getHeight();
      // Generar preview a 3x resolución para buena calidad
      var previewScale = 3;
      var cw = baseCw * previewScale;
      var ch = baseCh * previewScale;

      var tc = document.createElement('canvas');
      tc.width = cw;
      tc.height = ch;
      var tf = new fabric.StaticCanvas(tc, { width: cw, height: ch, backgroundColor: '#fff' });

      // Paso 1: Cargar fondo
      var loadBg = new Promise(function (r) {
        if (view && view.image) {
          fabric.Image.fromURL(view.image, function (img) {
            var scale = Math.min(cw / img.width, ch / img.height);
            img.set({ left: cw / 2, top: ch / 2, originX: 'center', originY: 'center', scaleX: scale, scaleY: scale });
            tf.add(img);
            r();
          }, { crossOrigin: 'anonymous' });
        } else { r(); }
      });

      // Paso 2: Cargar estampado DESPUÉS del fondo
      loadBg.then(function () {
        if (stamp && stamp.dataUrl) {
          fabric.Image.fromURL(stamp.dataUrl, function (img) {
            var p = stamp.position || {};
            img.set({
              left: (p.left || baseCw / 2) * previewScale,
              top: (p.top || baseCh / 2) * previewScale,
              originX: 'center',
              originY: 'center',
              scaleX: (p.scaleX || 1) * previewScale,
              scaleY: (p.scaleY || 1) * previewScale,
              angle: p.angle || 0,
            });
            tf.add(img);
            tf.renderAll();
            resolve(tf.toDataURL({ format: 'png', quality: 1.0 }));
            tf.dispose();
          });
        } else {
          tf.renderAll();
          resolve(tf.toDataURL({ format: 'png', quality: 1.0 }));
          tf.dispose();
        }
      });
    });
  }

  // ══════════════════════════════════
  //  ELIMINAR
  // ══════════════════════════════════
  function deleteCurrentImage() {
    if (!state.userImageObj) return;
    state.canvas.remove(state.userImageObj);
    state.userImageObj = null;

    var view = state.currentViews[state.currentViewIndex];
    if (view) {
      delete state.stampsByLocation[view.name];
    }

    state.canvas.renderAll();
    updateDeleteButton();
    updateSummary();
    hideMeasure();

    // Bloquear carrito y esperar que Dawn actualice la variante
    blockCartButton('Actualizando precio...');
    updateStampVariant();
    setTimeout(function () { unblockCartButton(); }, 1500);
  }

  function updateDeleteButton() {
    var btn = document.getElementById('pz-delete-btn');
    if (btn) btn.disabled = !state.userImageObj;
  }

  // ══════════════════════════════════
  //  RESUMEN
  // ══════════════════════════════════
  function getStampCount() {
    var c = 0;
    Object.keys(state.stampsByLocation).forEach(function (loc) {
      if (state.stampsByLocation[loc] && state.stampsByLocation[loc].dataUrl) c++;
    });
    return c;
  }

  function updateSummary() {
    var el = document.getElementById('pz-views-summary');
    if (!el) return;

    // Mostrar todas las ubicaciones únicas configuradas
    var allLocations = {};
    state.colorsList.forEach(function (color) {
      var views = state.viewsByColor[color] || [];
      views.forEach(function (v) { allLocations[v.name] = true; });
    });

    var html = '';
    var count = 0;
    Object.keys(allLocations).forEach(function (loc) {
      var has = !!(state.stampsByLocation[loc] && state.stampsByLocation[loc].dataUrl);
      if (has) count++;
      html += '<div class="personalizer__summary-row">' +
        '<span class="personalizer__summary-label">' + escapeHtml(loc) + ':</span>' +
        '<span class="personalizer__summary-value ' +
        (has ? 'personalizer__summary-value--active' : 'personalizer__summary-value--inactive') + '">' +
        (has ? 'Sí' : 'No') + '</span></div>';
    });

    html += '<div class="personalizer__summary-row" style="margin-top:6px;font-weight:700;">' +
      '<span>Total estampados:</span><span>' + count + '</span></div>';
    el.innerHTML = html;
  }

  // ══════════════════════════════════
  //  PREVIEW
  // ══════════════════════════════════
  function showPreview() {
    var grid = document.getElementById('pz-preview-grid');
    if (!grid) return;

    saveCurrentStamp();

    var hasAny = false;
    var html = '';
    var locations = [];

    Object.keys(state.stampsByLocation).forEach(function (loc) {
      var s = state.stampsByLocation[loc];
      if (s && s.dataUrl) {
        hasAny = true;
        locations.push(loc);
        html += '<div class="personalizer__preview-item">' +
          '<img id="pz-prev-' + loc.replace(/\s/g, '_') + '" src="" alt="' + escapeHtml(loc) + '">' +
          '<h4>' + escapeHtml(loc) + '</h4></div>';
      }
    });

    if (!hasAny) {
      showMessage('No hay estampados para previsualizar.', 'info');
      return;
    }

    grid.innerHTML = html;

    locations.forEach(function (loc) {
      exportViewPreview(loc).then(function (d) {
        var img = document.getElementById('pz-prev-' + loc.replace(/\s/g, '_'));
        if (img) img.src = d;
      });
    });

    document.getElementById('pz-preview-overlay').classList.add('personalizer__preview-overlay--visible');
  }

  function hidePreview() {
    document.getElementById('pz-preview-overlay').classList.remove('personalizer__preview-overlay--visible');
  }

  // ══════════════════════════════════
  //  UTILS
  // ══════════════════════════════════
  function formatNumber(n) { return n.toLocaleString('es-CL'); }
  function escapeHtml(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }

  function showMessage(text, type) {
    var e = document.getElementById('pz-message');
    if (!e) return;
    e.textContent = text;
    e.className = 'personalizer__message personalizer__message--' + type;
    if (type !== 'info') {
      setTimeout(function () { e.className = 'personalizer__message'; }, 4000);
    }
  }

  // Start
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
